// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBBz0K0uu9KxX-imNTLGmUDmr-nqskAvyA",
  authDomain: "blog-d4f9b.firebaseapp.com",
  projectId: "blog-d4f9b",
  storageBucket: "blog-d4f9b.appspot.com",
  messagingSenderId: "660639643816",
  appId: "1:660639643816:web:4c03048e5cc33f71632a9d"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
const db = getFirestore(app);

export { auth, provider, db};